export default "__VITE_ASSET__DgA85$tQ__"